import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'NL2br'
})

export class NL2brPipe implements PipeTransform {

  transform(value: string): string {
    // HTML-escape the raw value BEFORE introducing any markup so that
    // injected HTML in the input cannot survive when bound to [innerHTML]. (R2-10)
    const escaped = value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
    return escaped.replace(/\n/g, '<br/>');
  }
}